module.exports = ".header-less-tabs .mat-tab-group .mat-tab-header {\r\n  display: none;\r\n}\r\n\r\n.map-container {\r\n  padding-left: 17%;\r\n  padding-right: 17%;\r\n  min-height: 100vh;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/schedule/pages/cluster-schedule-page/cluster-schedule-page.component.css
// module id = ./src/app/schedule/pages/cluster-schedule-page/cluster-schedule-page.component.css
// module chunks = main